
let cartData = null;
const cosmoCareVariantId = 46892709707997; // COSMO Care - Monthly
const cosmoCareSellingPlanId = 6194397405 // Delivery every 30 Days

const cosmoCarePlusVariantId= 46892711510237; // COSMO Care - Plus
const cosmoCarePlusSellingPlanId= 6190727389; // Delivery every 30 Days

$(document).ready(function () {
  $('.pick-choose').click(function (e) {
    var param = $(this).attr('variant_id');
    $("#vid").val(param);
  });

  document.querySelectorAll('.pick-choose').forEach(item => {
    item.addEventListener('click', function() {
      let radioButton = item.querySelector('input[type="radio"]');
      radioButton.checked = true; // Set radio button to checked
    });
  });
});

function addCosmoCare() {

 var param=$("#vid").val();
     if (param == 2) {
    $("#cosmocareadd").addClass('disablebtn');
    jQuery.post('/cart/update.js', {
      updates: {
        "46892711510237": 0,
        "46892709707997": 0
      }
    }).done(function () {
      jQuery.post('/cart/add.js', {
        items: [{
          quantity: 1,
          id: 46892711510237,
          "selling_plan": 6190727389,
          purchase_type: 'autodeliver',
        }]
      }).done(function (e) {
        setTimeout(function () { $("#cosmocareadd").removeClass('disablebtn'); }, 3000);
        localStorage.setItem('cosmocare', 1);
        window.location = '/pages/winback-upsell';
      });
    });
  }
  else if (param == 1) {
    $("#cosmocareadd").addClass('disablebtn');
    jQuery.post('/cart/update.js', {
      updates: {
        
        "46892711510237": 0,
        "46892709707997": 0

      }
    }).done(function () {
      jQuery.post('/cart/add.js', {
        items: [{
          quantity: 1,
          id: 46892709707997,
          "selling_plan": 6194397405,
          purchase_type: 'autodeliver',
        }]
      }).done(function (e) {
        setTimeout(function () { $("#cosmocareadd").removeClass('disablebtn'); }, 3000);
        localStorage.setItem('cosmocare', 1);
        window.location = '/pages/winback-upsell';
      });
    });
  } else {
    jQuery.post('/cart/update.js', {
      updates: {
        46892709707997: 0,
        46892711510237: 0,
      }
    }).done(function () {
      localStorage.setItem('cosmocare', 0);
      window.location = '/pages/winback-upsell';
    });
  }
}